export default __webpack_public_path__ + "static/media/img_appdownload.b21d1b0a.png";